import React, { Component } from 'react';
import { Title, Product, Error } from '../../library';
import ProductButton from './ProductButton/ProductButton';
import { ReactComponent as Polygon } from '../../assets/images/polygon-down.svg';
import styles from './styles';
import { css } from 'aphrodite';

var prevProduct = '';

class ProductSelector extends Component {

    constructor(props) {
        super(props);
        this.state = {
            openedProduct: null,
            selectedProduct: null,
            isError: props.isError,
            isQuantityError: props.isQuantityError,
            isProductsListOpened: false,
        }
    }

    componentDidUpdate(prevProps, prevState) {
        if(prevProps.isError !== this.props.isError) {
            this.setState({isError: this.props.isError});
        }
        if(prevProps.isQuantityError !== this.props.isQuantityError) {
            this.setState({isQuantityError: this.props.isQuantityError});
        }
    }

    openProduct(product) {
        this.setState({ openedProduct: product });
    }

    openProductsList(e) {
        e.preventDefault();
        console.log('openProductsList')
        this.setState({isProductsListOpened: true})
        if (this.state.isProductsListOpened === false) {
            this.setState({isProductsListOpened: true})
        } else {
            this.setState({isProductsListOpened: false})
        }
    }

    selectProduct(product) {
        const { dataLayer } = this.props;

        this.setState({ openedProduct: null, selectedProduct: product }, ()=>{
            this.props.onProductSelected(product);

            if (prevProduct !== this.state.selectedProduct) {
                if (dataLayer !== null) {
                    dataLayer.push({
                        'event': 'typeOfJointSealantSelection',
                        'typeOfGrout': product.title,
                    });

                    console.log(dataLayer);
                }

                // Reset quantity if Selected Product is changed
                this.props.onQuantitySelected(null);
                prevProduct = product;
            }
        });
    }

    render() {
        const { title, linkTitle, products, errorLabel, errorPackagingLabel, dataLayer, imgUrl, cartridgeLabel, chooseLabel, titleCertificate, titleRelatedCleaners } = this.props;

        return (
            <div className={css(styles.productSelector)}>
                <Title reverse style={styles.h3}>{title}</Title>
                <div className={css(styles.wrapper, this.state.isError && styles.containerError)}>
                    <div className={css(styles.productListButtonMobile, this.state.isProductsListOpened && styles.productListButtonMobileOpened)}
                         onClick={(e)=>this.openProductsList(e)}>
                        Select a product
                        <span >
                            <Polygon className={css(styles.productListButtonMobileIcon, this.state.isProductsListOpened && styles.productListButtonMobileIconOpened)} />
                        </span>
                    </div>
                    <div className={css(styles.productList, this.state.isProductsListOpened && styles.productListOpened)}>
                    {products && products.map((product, index) => {
                        return(
                            <ProductButton
                                key={index}
                                product={product}
                                linkTitle={linkTitle}
                                isOpened={this.state.openedProduct && this.state.openedProduct.entityId === product.entityId}
                                isSelected={this.state.selectedProduct && this.state.selectedProduct.entityId === product.entityId}
                                onOpenProduct={() => this.openProduct(product)}
                                onSelectProduct={() => this.selectProduct(product)}
                                onQuantitySelected={(quantity) => {this.props.onQuantitySelected(quantity)}}
                                openProductsList={(e) => this.openProductsList(e)}
                                dataLayer={dataLayer}
                                selectedProduct={this.state.selectedProduct}
                                imgUrl={imgUrl}
                                cartridgeLabel={cartridgeLabel}
                            />
                        );
                    })}
                    </div>
                    {this.state.selectedProduct &&
                    <div className={css(styles.productContainer)}>
                        <Product
                            data={this.state.selectedProduct}
                            style={styles.product}
                            linkTitle={linkTitle}
                            dataLayer={dataLayer}
                            onQuantitySelected={(quantity) => {this.props.onQuantitySelected(quantity)}}
                            selectedProduct={this.state.selectedProduct}
                            titleCertificate={titleCertificate}
                            titleRelatedCleaners={titleRelatedCleaners}
                            isQuantityError={this.state.isQuantityError}
                            errorPackagingLabel={errorPackagingLabel}
                            chooseLabel={chooseLabel}
                            openProductsList={(e) => this.openProductsList(e)}
                        />
                    </div>
                    }
                </div>
                {this.state.isError &&
                    <div className={css(styles.error)}>
                        <Error label={errorLabel}/>
                    </div>
                }
            </div>
        );
    }
}

export default ProductSelector;
